/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BuilderGtoRoutingModule } from './builder-gto-routing.module';
import {
  GraphicalTakeOffChangeComponent,
  GraphicalTakeOffCloneComponent,
  GraphicalTakeOffCropComponent,
  GraphicalTakeOffDrawComponent,
  GraphicalTakeOffEditComponent,
  GraphicalTakeOffImportComponent,
  GraphicalTakeOffLevelComponent,
  GraphicalTakeOffMainComponent,
  GraphicalTakeOffMenuComponent,
  GraphicalTakeOffZoomComponent,
  GraphicalTakeOffCanvasComponent,
  GraphicalTakeOffCanvasTopComponent,
  GraphicalTakeOffCanvasDataBoxComponent,
  GraphicalTakeOffCanvasCountMeasurementComponent,
  GraphicalTakeOffCanvasLengthMeasurementComponent,
  GraphicalTakeOffCanvasImageComponent,
  GraphicalTakeOffCanvasTransformedImageComponent, GraphicalTakeOffCanvasScaleLineComponent,
} from './components';

import { GraphicalTakeOffPointValueDirective } from './directives';

@NgModule({
  imports: [
    PdfViewerModule,
    BuilderSharedModule.forChild(),
    BuilderGtoRoutingModule,
  ],
  declarations: [
    GraphicalTakeOffPointValueDirective,
    GraphicalTakeOffEditComponent,
    GraphicalTakeOffMainComponent,
    GraphicalTakeOffDrawComponent,
    GraphicalTakeOffMenuComponent,
    GraphicalTakeOffLevelComponent,
    GraphicalTakeOffCropComponent,
    GraphicalTakeOffImportComponent,
    GraphicalTakeOffChangeComponent,
    GraphicalTakeOffCloneComponent,
    GraphicalTakeOffZoomComponent,
    GraphicalTakeOffCanvasComponent,
    GraphicalTakeOffCanvasTopComponent,
    GraphicalTakeOffCanvasCountMeasurementComponent,
    GraphicalTakeOffCanvasLengthMeasurementComponent,
    GraphicalTakeOffCanvasDataBoxComponent,
    GraphicalTakeOffCanvasImageComponent,
    GraphicalTakeOffCanvasTransformedImageComponent,
    GraphicalTakeOffCanvasScaleLineComponent,
  ],
  entryComponents: [
    GraphicalTakeOffEditComponent,
    GraphicalTakeOffMainComponent,
    GraphicalTakeOffImportComponent,
    GraphicalTakeOffCloneComponent,
    GraphicalTakeOffZoomComponent,
    GraphicalTakeOffChangeComponent,
  ],
})
export class BuilderGtoModule {
}
